import "core-js/modules/es6.function.name";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _ from 'lodash';

var createShorthand = function createShorthand(name, type) {
  return {
    name: name,
    type: _.isUndefined(type) ? name : type
  };
};

export var SIDES = createShorthand('Sides', '');
export var CORNERS = createShorthand('Corners', '');
export var HORIZONTAL = createShorthand('Horizontal');
export var VERTICAL = createShorthand('Vertical');
export var LEFT = 'Left';
export var RIGHT = 'Right';
export var TOP = 'Top';
export var BOTTOM = 'Bottom';
export var TOP_RIGHT = 'TopRight';
export var BOTTOM_RIGHT = 'BottomRight';
export var TOP_LEFT = 'TopLeft';
export var BOTTOM_LEFT = 'BottomLeft';

var ShorthandsNormalizerFactory = function () {
  function ShorthandsNormalizerFactory() {
    var _this$createNormalize;

    _classCallCheck(this, ShorthandsNormalizerFactory);

    this.createNormalizersMap = (_this$createNormalize = {}, _defineProperty(_this$createNormalize, SIDES.name, this.createAllSidesNormalizer), _defineProperty(_this$createNormalize, CORNERS.name, this.createAllCornersNormalizer), _defineProperty(_this$createNormalize, HORIZONTAL.name, this.createHorizontalSidesNormalizer), _defineProperty(_this$createNormalize, VERTICAL.name, this.createVerticalSidesNormalizer), _this$createNormalize);
  }

  _createClass(ShorthandsNormalizerFactory, [{
    key: "createAllSidesNormalizer",
    value: function createAllSidesNormalizer(prop, shorthand) {
      var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      return function (val) {
        var _ref;

        return _ref = {}, _defineProperty(_ref, prop + LEFT + suffix, val), _defineProperty(_ref, prop + RIGHT + suffix, val), _defineProperty(_ref, prop + TOP + suffix, val), _defineProperty(_ref, prop + BOTTOM + suffix, val), _ref;
      };
    }
  }, {
    key: "createAllCornersNormalizer",
    value: function createAllCornersNormalizer(prop, shorthand) {
      var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      return function (val) {
        var _ref2;

        return _ref2 = {}, _defineProperty(_ref2, prop + BOTTOM_LEFT + suffix, val), _defineProperty(_ref2, prop + BOTTOM_RIGHT + suffix, val), _defineProperty(_ref2, prop + TOP_LEFT + suffix, val), _defineProperty(_ref2, prop + TOP_RIGHT + suffix, val), _ref2;
      };
    }
  }, {
    key: "createHorizontalSidesNormalizer",
    value: function createHorizontalSidesNormalizer(prop) {
      return function (val) {
        var _ref3;

        return _ref3 = {}, _defineProperty(_ref3, prop + LEFT, val), _defineProperty(_ref3, prop + RIGHT, val), _ref3;
      };
    }
  }, {
    key: "createVerticalSidesNormalizer",
    value: function createVerticalSidesNormalizer(prop) {
      return function (val) {
        var _ref4;

        return _ref4 = {}, _defineProperty(_ref4, prop + TOP, val), _defineProperty(_ref4, prop + BOTTOM, val), _ref4;
      };
    }
  }, {
    key: "getNormalizerCreator",
    value: function getNormalizerCreator(shorthand) {
      return this.createNormalizersMap[shorthand.name];
    }
  }, {
    key: "createNormalizer",
    value: function createNormalizer(prop, shorthand, suffix) {
      var normalizerCreator = this.getNormalizerCreator(shorthand);
      return normalizerCreator(prop, shorthand, suffix);
    }
  }]);

  return ShorthandsNormalizerFactory;
}();

export default new ShorthandsNormalizerFactory();